import { FixedPhraseTextKinds } from "./FixedPhraseTextKinds";

export class FixedPhraseTextKindConverter {
  private static readonly _text = "text";
  private static readonly _tag = "tag";

  public static getFixedPhraseTextKindText(kind: FixedPhraseTextKinds): string {
    return (kind === FixedPhraseTextKinds.Tag)
      ? this._tag
      : this._text;
  }

  public static getFixedPhraseTextKind(text: string): FixedPhraseTextKinds {
    return (text === this._tag)
      ? FixedPhraseTextKinds.Tag
      : FixedPhraseTextKinds.Text;
  }
}
